

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import EventDetails from "@/components/Event/EventDetails.vue";
import EventModal from "@/components/Event/EventModal.vue";
import { Event } from "@/types";
import moment, { Moment } from "moment";
import EventActions from "@/components/Event/EventActions.vue";
import EventCardImage from "@/components/Event/EventCardImage.vue";
import { mapGetters } from "vuex";
import axios from "@/plugins/axios";

@Component({
  components: { EventCardImage, EventActions, EventDetails, EventModal },
  computed: { ...mapGetters(["isLoggedIn"]) }
})
export default class EventCard extends Vue {
  @Prop() event!: Event;
  @Prop() width!: number;
  @Prop() height!: number;
  @Prop() history!: boolean;
  @Prop() ampm!: boolean;
  dialog = false;
  menu = false;
  deleteDialog = false;
  deleteLoading = false;
  intervals: { time: number; now: Moment } = { time: 0, now: moment() };

  mounted() {
    this.intervals.time = setInterval(() => {
      this.intervals.now = moment();
    }, 30000);
  }

  beforeDestroy() {
    clearInterval(this.intervals.time);
  }

  get time() {
    const timeFormat = this.ampm ? "h:mma" : "H:mm";
    if (this.intervals.now.isBetween(this.event.start, this.event.end)) {
      return "Now";
    } else if (
      this.event.start.isBetween(
        this.intervals.now.clone().startOf("day"),
        this.intervals.now.clone().endOf("day")
      )
    ) {
      return "Today at " + this.event.start.format(timeFormat);
    } else if (
      this.event.start.isBetween(
        this.intervals.now.clone().startOf("day"),
        this.intervals.now
          .clone()
          .add(1, "day")
          .endOf("day")
      ) &&
      (!this.small || !this.ampm)
    ) {
      return "Tomorrow at " + this.event.start.format(timeFormat);
    } else if (
      this.event.start.isBetween(
        this.intervals.now.clone().startOf("day"),
        this.intervals.now
          .clone()
          .add(1, "week")
          .startOf("day")
      )
    ) {
      if (this.small) {
        return this.event.start.format("ddd [at] " + timeFormat);
      } else {
        return this.event.start.format("dddd [at] " + timeFormat);
      }
    } else {
      return this.event.start.format("D MMM, " + timeFormat);
    }
  }

  get small() {
    return this.width < 300;
  }

  deleteEvent() {
    this.deleteLoading = true;
    axios
      .delete("/api/schedule/" + this.event.id)
      .then(() => {
        this.$emit("save");
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.deleteLoading = false;
      });
  }
}
